export const FETCH_EXTERNAL_PRACTITIONER_LIST_REQUEST = "FETCH_EXTERNAL_PRACTITIONER_LIST_REQUEST";
export const FETCH_EXTERNAL_PRACTITIONER_LIST_SUCCESS = "FETCH_EXTERNAL_PRACTITIONER_LIST_SUCCESS";
export const FETCH_EXTERNAL_PRACTITIONER_LIST_FAILURE = "FETCH_EXTERNAL_PRACTITIONER_LIST_FAILURE";
